export default "/assets/images/big-sneeze2.png?74b50490a969f834e6b1d90f94439fc5";